export const AUCKLAND_TIME_ZONE = 'Pacific/Auckland' as const

const WEEKDAY_INDEX: Record<string, number> = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }

function localDateParts(date: Date) {
  const parts = new Intl.DateTimeFormat('en-NZ', {
    timeZone: AUCKLAND_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
  }).formatToParts(date)
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]))
  return {
    year: Number(lookup.year), month: Number(lookup.month), day: Number(lookup.day),
    weekday: WEEKDAY_INDEX[lookup.weekday],
  }
}

function timeZoneOffsetMinutes(date: Date) {
  const part = new Intl.DateTimeFormat('en-NZ', {
    timeZone: AUCKLAND_TIME_ZONE, timeZoneName: 'longOffset',
  }).formatToParts(date).find((item) => item.type === 'timeZoneName')?.value ?? ''
  const match = part.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/)
  if (!match) throw new Error('Auckland time zone offset unavailable')
  const minutes = Number(match[2]) * 60 + Number(match[3] ?? 0)
  return match[1] === '-' ? -minutes : minutes
}

function aucklandMidnight(calendarDate: Date) {
  const localAsUtc = calendarDate.getTime()
  let offset = timeZoneOffsetMinutes(calendarDate)
  let instant = localAsUtc - offset * 60_000
  const correctedOffset = timeZoneOffsetMinutes(new Date(instant))
  if (correctedOffset !== offset) {
    offset = correctedOffset
    instant = localAsUtc - offset * 60_000
  }
  return new Date(instant)
}

// UTC is only a carrier for local calendar arithmetic. Convert each endpoint
// separately so weeks spanning Auckland DST can contain 167 or 169 hours.
export function currentDropRange(now: Date) {
  const local = localDateParts(now)
  const daysSinceMonday = (local.weekday + 6) % 7
  const monday = new Date(Date.UTC(local.year, local.month - 1, local.day - daysSinceMonday))
  const nextMonday = new Date(Date.UTC(monday.getUTCFullYear(), monday.getUTCMonth(), monday.getUTCDate() + 7))
  return { start: aucklandMidnight(monday), end: aucklandMidnight(nextMonday) }
}

// Context for the current operational week only, never a stored order's date.
export function operationalWeekendLabels(weekStartsAt: string) {
  const local = localDateParts(new Date(weekStartsAt))
  const formatter = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  })
  const label = (days: number) => formatter.format(new Date(Date.UTC(local.year, local.month - 1, local.day + days)))
  return { saturday: label(5), sunday: label(6) }
}
